import React, { useEffect, useState } from 'react';
import { useAuthStore } from 'src/store/auth';
import { useApplicationStore } from 'src/store/application';

const ThanksPage: React.FC = () => {
  const [userName, setUserName] = useState('');
  const { user } = useAuthStore();
  const { applications } = useApplicationStore();

  useEffect(() => {
    if (applications.length > 0) {
      setUserName(applications[0]?.applicants[0]?.firstName);
    }
  }, [applications]);

  return (
    <main className="w-full relative rounded-3xl bg-card flex flex-col justify-between 2xl:flex-row gap-4 max-xl:min-h-102.5 h-full overflow-hidden">
      <article className="flex flex-col gap-3 pt-15 bg-card z-10 md:pt-36 pb-10 px-6 md:pr-2 md:pl-12 md:gap-4 max-md:items-center min-2xl:min-w-82 min-3xl:max-w-[650px]">
        <h1 className="text-black text-4xl lg:text-[56px] 2xl:text-[44px] 3xl:text-[56px] 2xl:text-wrap font-extrabold max-md:text-2xl">
          Thank you, {user ? userName || user.firstName || user.username : 'user'}!
        </h1>
        <p className="text-xl text-[18px] lg:text-[22px] 2xl:text-[18px] 3xl:text-[22px] !font-secondary max-md:text-center">
          You’re all set! You’ll receive an email shortly with instructions on how to access your Health Portal, view your benefits, and download your insurance cards. We’re excited to have you on board and here to support you every step of the way.
        </p>
      </article>
      <img
        src="/images/thanks.png"
        alt="thanks-img"
        className="flex mt-auto h-full max-h-[790px] max-5xl:max-h-[720px] max-3xl:max-h-[630px] object-cover object-left-top"
      />
    </main>
  );
};

export default ThanksPage;
